import(/* webpackMode: "eager" */ "/app/node_modules/@headlessui/react/dist/components/tabs/tabs.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["AdminSettings"] */ "/app/src/app/(library)/webapps/[slug]/settings/admin.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GeneralSettings"] */ "/app/src/app/(library)/webapps/[slug]/settings/general.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageSettings"] */ "/app/src/app/(library)/webapps/[slug]/settings/images.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PermissionSettings"] */ "/app/src/app/(library)/webapps/[slug]/settings/permissions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebAppProvider"] */ "/app/src/hooks/webapp.tsx");
